import { AuthSevices } from 'libs/api/src/lib/auth.service';
import {
  UntypedFormControl,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import {
  TENANTS_INFO,
  STAFF_STATE,
  COMPANY_INFO,
  STATSIG_STATE,
} from 'apps/ff-frontend/src/app/state/app.state';
import { Store } from '@ngrx/store';
import { AppState } from 'apps/ff-frontend/src/app/state/app.state';
import {
  Observable,
  of,
  BehaviorSubject,
  Subject,
  interval,
  switchMap,
  catchError,
  Subscription,
} from 'rxjs';
import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  LOCALE_ID,
  Inject,
  ViewChild,
  Renderer2,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import {
  Client,
  StaffNotificationResponse,
  TENANTSINTERFACE,
  TENANT_MODEL,
} from '@fitness-force/models';
import { StyleClassModule } from 'primeng/styleclass';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { SearchPipeModule } from 'libs/shared/src/lib/filters/searchtenant.pipe';
import { DividerModule } from 'primeng/divider';
import { AvatarModule } from 'primeng/avatar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { SET_ACTIVE_TENANT } from 'apps/ff-frontend/src/app/state/actions';
import {
  ClientService,
  OmniSearchService,
  StaffNotificationService,
  TenantService,
} from '@fitness-force/api';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  ClientOmnisearchModule,
  RouteStateService,
} from '@fitness-force/shared';
import { DrawerModule } from 'primeng/drawer';
import { ClientInfoSidebarComponent } from '../client-info-sidebar/client-info-sidebar.component';
import { ScrollerModule as VirtualScrollerModule } from 'primeng/scroller';
import { MultiTenantListComponent } from '../multi-tenant-list/multi-tenant-list.component';
import { StaffNotificationSidebarComponent } from '../staff-notification-sidebar/staff-notification-sidebar.component';
import Statsig from 'statsig-js';
import { ProspectFormComponent } from '../prospect-form/prospect-form.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { BillingComponent } from '@fitness-force/billing';
import { AUTH_STATE } from 'apps/ff-frontend/src/app/state/app.state';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SelectButtonModule,
    StyleClassModule,
    SelectModule,
    ButtonModule,
    AutoCompleteModule,
    SearchPipeModule,
    DividerModule,
    AvatarModule,
    RouterModule,
    TranslateModule,
    DrawerModule,
    VirtualScrollerModule,
    MultiTenantListComponent,
    ClientInfoSidebarComponent,
    StaffNotificationSidebarComponent,
    ProspectFormComponent,
    BillingComponent,
    ClientOmnisearchModule
]
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input('tenantList') tenantList: TENANTSINTERFACE | any;
  @Output('emittedTenant') emittedTenant = new EventEmitter<TENANT_MODEL>();
  @Output('emitProspect') emitProspectEvent = new EventEmitter<boolean>();
  @Output('taskModified') taskModified = new EventEmitter<boolean>();
  zoneWiseTenantList: any = [];
  selectedTenant?: TENANT_MODEL;
  searchTenants: UntypedFormControl = new UntypedFormControl('');
  allTenantsControls: UntypedFormControl = new UntypedFormControl('');
  tenantOriginalValue: TENANTSINTERFACE;
  createProspect = new BehaviorSubject<boolean>(false);
  userDetails$ = new BehaviorSubject<any>([]);
  allStaffs$ = new BehaviorSubject([]);
  getAccessTenantList$: Observable<any> | any;
  statsgis$: Observable<any> | any;
  selectedClient: any;
  filteredClient$: BehaviorSubject<Client[]> = new BehaviorSubject(
    [] as Client[]
  );

  currentUserDetails: any;
  showClientSidebar = false;
  activeClientId!: number | null;

  allTenants: any[] = [];
  tenantId: any;
  selectedTenantField: UntypedFormControl = new UntypedFormControl('');
  sidebarMinimized = false;

  @ViewChild('autoComplete') autoComplete: any;
  isScrolling: boolean = false;
  pageNumber = 0;
  pageSize: number = 10; // Adjust this value as per your requirement
  query: string = '';

  appConfig = { workspaceAlias: 'unifiedfitnessplatform' };
  olvyUtils: any;
  companyInfoDetail: any;
  public companyInfoDetail$!: Observable<any>;
  private searchText$ = new Subject<string>();
  isGlobal: boolean = false;
  pageNames = [
    { name: 'tenants', url: '/admin/tenant-list' },
    { name: 'create-tenant', url: '/admin/tenant-list/create-tenant' },
  ];

  showNotificationSidebar: boolean = false;
  private pollingSubscription: Subscription | undefined;
  private authStateSubscription: Subscription | undefined;
  staffNotifications = new BehaviorSubject<StaffNotificationResponse[]>([]);
  showStaffNotificationIcon = new BehaviorSubject<boolean>(false);
  staffNotificationCount = 0;

  showProspect: boolean = false;
  clientId: number = 0;
  formType: string = 'prospect';

  themes = [
    { label: 'Light', value: 'lara-light-blue' },
    { label: 'Dark', value: 'lara-dark-blue' },
    { label: 'Bootstrap Light', value: 'bootstrap4-light-blue' },
    { label: 'Bootstrap Dark', value: 'bootstrap4-dark-blue' }
  ];
  selectedTheme = 'lara-light-blue';

  showPaidFullSidebar:boolean = false;
  planSummarydataObject$ = new BehaviorSubject<any>(null);
  activeTab: string = 'overview';

  private statsigSubscription: Subscription | undefined;
  searchData: { name?: string; email?: string; mobile?: string; };

  private visibilitySubscription: Subscription | undefined;
  private lastPollingTime: number = 0;
  private readonly pollingInterval = 1 * 60 * 1000; // 1 minute in milliseconds

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private clientService: ClientService,
    private authService: AuthSevices,
    private omniSearchService: OmniSearchService,
    public translate: TranslateService,
    private renderer: Renderer2,
    private activeRoute: ActivatedRoute,
    private tenantService: TenantService,
    @Inject(LOCALE_ID) public locale: string,
    public cdr: ChangeDetectorRef,
    public routeStateService: RouteStateService,
    public staffNotification: StaffNotificationService
  ) {
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
  }

  ngOnInit(): void {
    this.componentInit();
    this.routeStateService.closeSidebar$.subscribe({
      next: (value) => {
        this.showClientSidebar = false;
      },
    });

    // Subscribe to auth state to handle logout
    this.authStateSubscription = this.store.select(AUTH_STATE).subscribe({
      next: (authState: any) => {
        if (!authState.loggedIn) {
          // Stop polling when logged out
          this.pollingSubscription?.unsubscribe();
          this.pollingSubscription = undefined;
        }
      }
    });

    // Add visibility change listener
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  componentInit() {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.statsgis$ = this.store.select(STATSIG_STATE);
    this.companyInfoDetail$ = this.store.select(COMPANY_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      if (tenant.selected_tenant.id > 0) {
        this.tenantId = tenant.selected_tenant.id;
        if (!this.selectedTenant)
          // IMPORTANT TO HIDE DROP DOWN..
          this.getGroupData(tenant.accessed_tenant, tenant.selected_tenant);
        this.tenantOriginalValue = tenant;
        this.selectedTenant = tenant.selected_tenant;
        this.allTenants = tenant.accessed_tenant;
      }
    });

    // Clean up previous subscription if exists
    this.statsigSubscription?.unsubscribe();
    
    // Subscribe to statsig state
    this.statsigSubscription = this.statsgis$.subscribe((responseData: any) => {
      if(responseData && responseData.user){
        if(Statsig.checkGate("show_staff_2way_message_notifciation")) {
          this.showStaffNotificationIcon.next(true);
          // Only start polling if not already polling
          if (!this.pollingSubscription) {
            this.startPolling();
          }
        } else {
          this.showStaffNotificationIcon.next(false);
          // Stop polling if feature flag is turned off
          this.pollingSubscription?.unsubscribe();
          this.pollingSubscription = undefined;
        }
      }
      this.cdr.detectChanges();
    });

    this.companyInfoDetail$.subscribe((responseData) => {
      if (responseData?.selectedLang?.LANG_CODE) {
        this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
        this.translate.use(responseData?.selectedLang?.LANG_CODE);
      }

      if (responseData.compDetails != null) {
        this.companyInfoDetail = responseData.compDetails;
      }
    });

    this.activeRoute.queryParams.subscribe({
      next: (queryParms) => {
        if (
          queryParms.tenant &&
          this.selectedTenant &&
          queryParms.tenant != this.selectedTenant.id
        ) {
          const selected_tenant = this.allTenants.find((tenant: any) => {
            return queryParms.tenant == tenant.id;
          });
          if (selected_tenant) {
            //this.selectedTenant= selected_tenant;
            this.store.dispatch(SET_ACTIVE_TENANT({ selected_tenant }));
            this.emittedTenant.emit(selected_tenant);
          }
        }
      },
    });

    this.currentUserDetails = this.authService.currentUserDetails();

    if (this.currentUserDetails) {
      this.store.select(STAFF_STATE).subscribe((data: any) => {
        if (data && data.staffList && data.staffList.length > 0) {
          const filterDate = data.staffList.filter((o: any) => {
            return o.id === parseInt(this.currentUserDetails.Id);
          });
          if (filterDate) {
            this.userDetails$.next(filterDate[0]);
          }
        }
      });
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.pageNames.find((page) => page.url == event.url)) {
          this.isGlobal = true;
        } else this.isGlobal = false;
      }
    });
  }

  getNotifications() {
    this.staffNotification.getStaffNotifications().subscribe({
      next: (data) => {
        var res = data.items as StaffNotificationResponse[];
        this.staffNotifications.next(res ? res : []);
        this.staffNotificationCount = res ? res.filter(o => o.tenant_id == this.tenantId).length : 0;
        this.routeStateService.setStaffNotifications(res ? res :[]);
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Polling error:', err);
        this.staffNotifications.next([]);
        this.cdr.detectChanges();
      },
    });
  }

  private handleVisibilityChange(): void {
    if(Statsig.checkGate("show_staff_2way_message_notifciation")) {
      if (document.hidden) {
        // Stop polling when page is hidden
        this.pollingSubscription?.unsubscribe();
        this.pollingSubscription = undefined;
        // Store the last polling time
        this.lastPollingTime = Date.now();
      } else {
        // Page is visible again
        const timeSinceLastPoll = Date.now() - this.lastPollingTime;
        
        // If it's been longer than our polling interval since the last poll,
        // do an immediate poll and restart the interval
        if (timeSinceLastPoll >= this.pollingInterval) {
          this.getNotifications();
        }
        // Restart polling
        this.startPolling();
      }
    }
    
  }

  startPolling(): void {
    // Prevent multiple polling subscriptions
    if (this.pollingSubscription || document.hidden) {
      return;
    }

    // Make an immediate call first
    this.getNotifications();

    // Then start the interval
    this.pollingSubscription = interval(this.pollingInterval)
      .pipe(
        // Only continue if the page is visible
        switchMap(() => {
          if (document.hidden) {
            return of(null);
          }
          return this.staffNotification.getStaffNotifications();
        }),
        catchError((err) => {
          console.error('Polling error:', err);
          this.pollingSubscription?.unsubscribe();
          this.pollingSubscription = undefined;
          this.cdr.detectChanges();
          return of([]); // Return empty array on error
        })
      )
      .subscribe({
        next: (data) => {
          if (data) {  // Only update if we got actual data (not null from hidden state)
            this.staffNotifications.next(data.items ? data.items : []);
            this.staffNotificationCount = data.items ? data.items.filter((o:any) => o.tenant_id == this.tenantId).length : 0;
            this.routeStateService.setStaffNotifications(data.items ? data.items : []);
            this.cdr.detectChanges();
          }
        },
        error: (err) => {
          this.staffNotifications.next([]);
          this.pollingSubscription?.unsubscribe();
          this.pollingSubscription = undefined;
          this.cdr.detectChanges();
        },
      });
  }

  onScroll(event: Event) {
  }

  get SelectedTenantField(): UntypedFormControl {
    return this.selectedTenantField as UntypedFormControl;
  }

  selectTenant(event: any) {
    const selected_tenant = event;
    if (this.selectedTenant && selected_tenant.id == this.selectedTenant?.id)
      return;
    //this.selectedTenant= selected_tenant;
    this.store.dispatch(SET_ACTIVE_TENANT({ selected_tenant }));
    this.tenantService.updateTenantPresaleStatus(selected_tenant);
    this.emittedTenant.emit(selected_tenant);
    const currentUrl = this.router.url;
    if (
      currentUrl === '/tenant-not-found' &&
      selected_tenant.status.toLowerCase() == 'active'
    ) {
      this.router.navigate(['/crm/sales-pipeline']);
    }
    this.store.dispatch({ type: 'ROUTER_GO' });
    this.cdr.detectChanges();
  }

  get AllTenantsControls(): UntypedFormControl {
    return this.allTenantsControls as UntypedFormControl;
  }

  getGroupData(tenantList: any, selected: any): void {
    /* Filter tenant list zone wise */
    this.zoneWiseTenantList = this.groupByZone(tenantList);

    // Set active tenant value
    // Setting Values ..
    if (!this.SelectedTenantField.value) {
      this.SelectedTenantField.setValue(
        tenantList.find((tenant: any) => tenant.id == selected?.id)
      );
    }
  }

  groupByZone(tenantList: any): { Zone: string; items: any[] }[] {
    const groupedData: { [key: string]: any[] } = {};

    tenantList.forEach((tenant: any) => {
      const zone = tenant.zone;
      if (!groupedData[zone]) {
        groupedData[zone] = [];
      }
      groupedData[zone].push(tenant);
    });

    return Object.keys(groupedData).map((zone) => ({
      Zone: zone,
      items: groupedData[zone],
    }));
  }

  hidePopup(clientId: number) {
    this.createProspect.next(false);
    this.emitProspectEvent.emit(false);
  }

  createProspectEvent(event:any) {
    if (!this.isTenantInActive)
      {
        this.formType = event.formType;
        this.searchData = event.searchData;
        this.createProspect.next(true);
      }
  }

  OpenPopup(formType:string) {
    if (!this.isTenantInActive)
      {
        this.formType = formType;
        this.createProspect.next(true);
      }
  }


  navigateToClientProfile(client: Client) {
    this.activeClientId = client.clt_id;
    this.showClientSidebar = true;
  }

  goToclientProfile(event: any) {
    this.activeClientId = event.clientId;
    this.showClientSidebar = true;
  }

  goToClientProfileDetails(event: any) {
    this.activeClientId = event.clientId;
    this.activeTab = event.tab;
    switch(event.tab){
      case 'pos-addon-charges':
        this.router.navigate(['/pos/pos-addon-charges/', event.clientId]);
        break;
      case 'appointment':
        this.showClientSidebar = true;
        break;
      case 'check-in':
        this.router.navigate(['/client-management/check-in', event.clientId]);
        break;
      case 'transactions':
        this.activeTab = 'transactions';
        this.showClientSidebar = true;
        break;
      case 'subscriptions':
        this.activeTab = 'subscriptions';
        this.showClientSidebar = true;
        break;
      default:
        this.activeTab = 'overview';
        this.showClientSidebar = true;
        break;
    }
    
  }

  addClass(event: Event) {
    const clickedElement = event.target as HTMLElement;
    const classesToAdd = ['fa-spin', 'fa-spinner'];
    classesToAdd.forEach((className) => {
      this.renderer.addClass(clickedElement.firstElementChild, className);
    });
  }

  removeClass(event: Event) {
    const clickedElement = event.target as HTMLElement;
    const classesToAdd = ['fa-spin', 'fa-spinner'];
    classesToAdd.forEach((className) => {
      this.renderer.removeClass(clickedElement.firstElementChild, className);
    });
  }

  taskUpdated(event: boolean) {
    this.taskModified.emit(event);
  }

  CloseSidebar(event: any) {
    this.showClientSidebar = false;
    this.cdr.detectChanges();
  }

  getTenant(client: any) {
    if (client && client.clt_home_club_tenant_id != 0)
      return this.allTenants.find(
        (t: any) => t.id == client.clt_home_club_tenant_id
      );
    else if (client && client.clt_createdin_tenant_id != 0)
      return this.allTenants.find(
        (t: any) => t.id == client.clt_createdin_tenant_id
      );
    else return null;
  }

  get isTenantInActive(): boolean {
    return (
      this.selectedTenant! &&
      this.selectedTenant!.status.toLowerCase() == 'inactive'
    );
  }

  openChangeLog() {
    window.Featurebase('manually_open_changelog_popup');
    // window.open("https://feedback.unifiedfitnessplatform.ai/changelog", "_blank");
  }

  closeNotificationSidebar(event: { close: boolean; reloadData: boolean }) {
    if(event.close) this.showNotificationSidebar = false;
    if (event.reloadData) {
      this.getNotifications();
    }
    this.cdr.detectChanges();
  }

  proceedToSignup(event:{proceesToSignup:boolean,Data:any}){
    if(event.proceesToSignup){
      this.planSummarydataObject$.next(event.Data);
      this.showPaidFullSidebar = event.proceesToSignup;
    }
  } 

  hideBillingSummary(event:any){
    this.showPaidFullSidebar = false;
  }

  get SearchTenants() {
    return this.searchTenants.value;
  }

  ngOnDestroy(): void {
    this.pollingSubscription?.unsubscribe();
    this.authStateSubscription?.unsubscribe();
    this.statsigSubscription?.unsubscribe();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }
}
